export default __webpack_public_path__ + "static/media/verify.1931fea4.png";